import DataService from "@/services/DataService";

export default {
  getAll() {
    return DataService.apiClient.get("/meal/items");
  },

  get(id) {
    return DataService.apiClient.get("/meal/item/" + id);
  },
  findByName(name) {
    return DataService.apiClient.get("/meal/findbyname/" + name);
  },
  removeFile(id, filename) {
    return DataService.apiClient.patch("/meal/deleteImage", {
      _id: id,
      filename
    });
  },
  save(item) {
    //console.log(item);
    if (item.id != null) {
      return DataService.apiClient.patch("/meal/edit/" + item.id, item.data);
    } else {
      return DataService.apiClient.post("/meal/add", item.data);
    }
  },
  delete(id) {
    return DataService.apiClient.delete("/meal/delete/" + id);
  },
  deleteMeals(ids) {
    return DataService.apiClient.post("/meal/delete/", { items: ids });
  },

  getMealCategories() {
    return DataService.apiClient.get("/meal/categories/");
  }
};
